import React from 'react';
import {string, any} from 'prop-types';

const TextBlockButton = ({
    value,
    themeClass,
}) => {
    const rootTheme = themeClass || 'block-button-theme--text';
    return (
        <div className={`b-rit-block-button ${rootTheme}`}>
            {value}
        </div>
    );
}

TextBlockButton.propTypes = {
    value: any,
    themeClass: string,
}

export default TextBlockButton;